export const TEMPLATE_VARIABLES = [
  { key: "{nombre}", desc: "Nombre del pasajero" },
  { key: "{destino}", desc: "Destino del viaje" },
  { key: "{fecha_salida}", desc: "Ej: 25 de noviembre" },
  { key: "{fecha_regreso}", desc: "Ej: 2 de diciembre" },
  { key: "{dias_faltantes}", desc: "Días hasta la salida (\"en {dias_faltantes} días\" → \"mañana\" si falta 1)" },
  { key: "{detalles}", desc: "Detalles del viaje" },
  { key: "{vendedor}", desc: "Vendedor asignado" },
  { key: "{link_vouchers}", desc: "Link a los vouchers del viaje" },
  { key: "{link_encuesta}", desc: "Link a la encuesta post viaje" },
];

export const TemplateVarsHint = ({ compact = false }) => (
  <div className="text-xs text-sky-700/80" data-testid="template-vars-hint">
    <div className="flex flex-wrap gap-1">
      {TEMPLATE_VARIABLES.map((v) => (
        <code key={v.key} title={v.desc} className="bg-sky-50 border border-sky-100 px-1.5 py-0.5 rounded">
          {v.key}
        </code>
      ))}
    </div>
    {!compact && (
      <p className="mt-1.5 text-sky-600/70">
        Si una variable no tiene dato, se omite la frase que la contiene. Las viejas {"{name}"}, {"{days}"}, {"{date}"} y {"{details}"} siguen funcionando.
      </p>
    )}
  </div>
);
